import {getPage} from './pages'
// import {getPageConf, getUIMeta} from './configs'
const getPageConf = () => {}
export {
  getPage,
  getPageConf
  // getUIMeta
}




// WEBPACK FOOTER //
// ./src/pages/index.js